import Result from "@/core/common/Result";

export interface IBuscarVoucherUseCaseOutput {
  id: string;
  start: string | null;
}

export interface IBuscarVoucherUseCase {
  getVoucher(): Promise<Result<IBuscarVoucherUseCaseOutput>>;
}

export const buscarVoucherUseCaseDI = "buscarVoucherUseCase";
